import { render, staticRenderFns } from "./zuifan.vue?vue&type=template&id=1465c680"
import script from "./zuifan.vue?vue&type=script&lang=ts"
export * from "./zuifan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports